
















import { Vue, Component } from 'vue-property-decorator';

import SignUpService from '@/api/SingupService';

import { BusinessOnboardingState } from '@/models/business-onboarding';
import ModalOptions from '@/components/Modal/ModalOptions';

import MerchantOauthConnect from '@/utils/merchantoauth';
import eventBus from '@/utils/eventBus';

import ProviderConnectionForm from '@/componentsV2/templates/ProviderConnectionFormV2/ProviderConnectionForm.vue';

import InternationalizationService from '@/api/InternationalizationService';
import { scrollToTop } from '@/utils/scrollToTop';
import segmentIo from '@/utils/segment.io';

@Component({
  components: {
    ProviderConnectionForm
  }
})
export default class StoreProviderList extends Vue {
  signUpService: SignUpService = new SignUpService();
  internationalizationService = new InternationalizationService();
  loading = false;

  get yourStoreFormData() {
    return this.$store.getters['businessOnboarding/getYourStoreForm'];
  }

  get defaultFormData() {
    return this.$store.getters['businessOnboarding/getStoreDetailsForm']
      .providerConnection;
  }

  get businessOnboardingState(): BusinessOnboardingState {
    return this.$store.getters[
      'businessOnboarding/getBusinessOnboardingState'
    ] as BusinessOnboardingState;
  }

  mounted() {
    scrollToTop('bo-base-layout__right');
  }

  private getSession() {
    const session = JSON.parse(
      localStorage.getItem('@twism:bi-session') || 'null'
    );

    if (!session || session.ts < Date.now() - 1000 * 60 * 15) return null;

    return session.sid;
  }

  handleProviderConnection(formData: Record<string, any>) {
    const { link, links } = formData;

    const params = new URLSearchParams();

    if (link) {
      params.set('shop', link);
    }

    params.set('sid', this.getSession());

    this.$store.dispatch('businessOnboarding/SET_STORE_DETAILS_FORM', {
      providerConnection: formData
    });

    segmentIo.track('BFR Sign Up | Redirected to Provider');

    MerchantOauthConnect(links, 'signup', params.toString());
  }

  openOtherSelectModal(platformName: string, email: string) {
    eventBus.$emit(
      'openSubModal',
      new ModalOptions(
        ``,
        ``,
        'none',
        true,
        ``,
        ``,
        ``,
        false,
        'newProviderNotifyModal',
        false,
        true,
        true
      ),
      {
        buttonLabel: 'Got it',
        platformName,
        email,
        onConfirm: () => {
          eventBus.$emit('closeModal');
        },
        onClose: () => {
          eventBus.$emit('closeModal');
        }
      }
    );
  }

  async onOtherSelect({ platformName, email }: Record<string, any>) {
    this.loading = true;

    const formatPartner = String(platformName).toLowerCase();

    this.$ga.event({
      eventCategory: 'business-integrations',
      eventAction: 'submit-other-platform',
      eventLabel: formatPartner
    });

    await this.internationalizationService.reportNewIntegrationWithoutUser({
      type: 'provider',
      comment: formatPartner,
      email
    });

    this.loading = false;
    this.openOtherSelectModal(formatPartner, email);
  }

  onSubmit(formData: Record<string, any>) {
    if (formData.provider === 'other') {
      this.onOtherSelect(formData);
      return;
    }

    this.handleProviderConnection(formData);
  }
}
